import hero768Avif from "@/assets/optimized/hero-home-768.avif";
import hero1280Avif from "@/assets/optimized/hero-home-1280.avif";
import hero1920Avif from "@/assets/optimized/hero-home-1920.avif";
import hero768Webp from "@/assets/optimized/hero-home-768.webp";
import hero1280Webp from "@/assets/optimized/hero-home-1280.webp";
import hero1920Webp from "@/assets/optimized/hero-home-1920.webp";
import heroJpg from "@/assets/optimized/hero-home.jpg";

import onsite640Avif from "@/assets/optimized/trust-onsite-640.avif";
import onsite960Avif from "@/assets/optimized/trust-onsite-960.avif";
import onsite640Webp from "@/assets/optimized/trust-onsite-640.webp";
import onsite960Webp from "@/assets/optimized/trust-onsite-960.webp";
import onsiteJpg from "@/assets/optimized/trust-onsite.jpg";

import honest640Avif from "@/assets/optimized/trust-honest-640.avif";
import honest960Avif from "@/assets/optimized/trust-honest-960.avif";
import honest640Webp from "@/assets/optimized/trust-honest-640.webp";
import honest960Webp from "@/assets/optimized/trust-honest-960.webp";
import honestJpg from "@/assets/optimized/trust-honest.jpg";

import experience640Avif from "@/assets/optimized/trust-experience-640.avif";
import experience960Avif from "@/assets/optimized/trust-experience-960.avif";
import experience640Webp from "@/assets/optimized/trust-experience-640.webp";
import experience960Webp from "@/assets/optimized/trust-experience-960.webp";
import experienceJpg from "@/assets/optimized/trust-experience.jpg";

function srcset(...parts: Array<[string, number]>) {
  return parts.map(([url, width]) => `${url} ${width}w`).join(", ");
}

export const heroHomeImage = {
  avifSrcSet: srcset([hero768Avif, 768], [hero1280Avif, 1280], [hero1920Avif, 1920]),
  webpSrcSet: srcset([hero768Webp, 768], [hero1280Webp, 1280], [hero1920Webp, 1920]),
  src: heroJpg,
  width: 1920,
  height: 1080,
  sizes: "100vw",
};

export const heroHomePreloadHref = hero1280Avif;

export const trustOnsiteImage = {
  avifSrcSet: srcset([onsite640Avif, 640], [onsite960Avif, 960]),
  webpSrcSet: srcset([onsite640Webp, 640], [onsite960Webp, 960]),
  src: onsiteJpg,
  width: 960,
  height: 640,
  sizes: "(min-width: 768px) 30vw, 100vw",
};

export const trustHonestImage = {
  avifSrcSet: srcset([honest640Avif, 640], [honest960Avif, 960]),
  webpSrcSet: srcset([honest640Webp, 640], [honest960Webp, 960]),
  src: honestJpg,
  width: 960,
  height: 640,
  sizes: "(min-width: 768px) 30vw, 100vw",
};

export const trustExperienceImage = {
  avifSrcSet: srcset([experience640Avif, 640], [experience960Avif, 960]),
  webpSrcSet: srcset([experience640Webp, 640], [experience960Webp, 960]),
  src: experienceJpg,
  width: 960,
  height: 640,
  sizes: "(min-width: 768px) 30vw, 100vw",
};
